// RESPONSIVE VIDEO!
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// DETAILS TOGGLING
// PRODUCT PICKER
// VIDEO POP-UP
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// PLACE SLOT MODULE INSIDE THE LP


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

// const vid = document.getElementById('msdw-video-responsive');

// function loadVideo() {
//   var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
//       md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
//       lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
//       xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

//   sm.addEventListener("change", changeVideoSize);
//   md.addEventListener("change", changeVideoSize);
//   lg.addEventListener("change", changeVideoSize);
//   xl.addEventListener("change", changeVideoSize);

//   if      (sm.matches) { changeVideoSize('sm') }
//   else if (md.matches) { changeVideoSize('md') }
//   else if (lg.matches) { changeVideoSize('lg') }
//   else if (xl.matches) { changeVideoSize('xl') }
// }

// function changeVideoSize(size){
//   const videoSource = $("#msdw-video-responsive source");
//   videoSource.attr("src", videoSource.attr("data-video-"+size));
//   vid.autoplay = true;
//   vid.load();
//   // console.log(videoSource.attr("src"));
// }

// if (document.contains(vid)) {
//   document.addEventListener('DOMContentLoaded', loadVideo);
//   window.onresize = loadVideo;
//   // vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
// }

// // window.addEventListener('resize', () => vid.attr('hidden' = true));


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));

//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliderHotspots1 = new Swiper("#sliderHotspots1", {
  slidesPerView: 1.5,
  spaceBetween: 10,
  loop: false,
  // navigation: {
  //   nextEl: ".msdw-hotspots-button-next",
  //   prevEl: ".msdw-hotspots-button-prev",
  // },
  breakpoints: {
    navigation: false,
    600: {
      noSwipingClass: "msdw-no-swipe-md",
      slidesPerView: 3,
      spaceBetween: 15,
    },
    900: {
      noSwipingClass: "msdw-no-swipe-md",
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

const sliderHotspots2 = new Swiper("#sliderHotspots2", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  navigation: {
    nextEl: "#sliderHotspots2 .msdw-hotspots-button-next",
    prevEl: "#sliderHotspots2 .msdw-hotspots-button-prev",
  },
  breakpoints: {
    navigation: false,
    600: {
      slidesPerView: 1.65,
      spaceBetween: 15,
      navigation: false,
    },
    900: {
      noSwipingClass: "msdw-no-swipe-lg",
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: false,
    },
  },
});

let sliderFreeMode = new Swiper(".swiper-freemode", {
  slidesPerView: 1.3,
  spaceBetween: 10,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    600: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
  },
});


// product detail slider with thumbs

const sliderProductImgs = document.querySelectorAll(".swiper-product-img");
const sliderProductThumbs = document.querySelectorAll(
  ".swiper-product-img-thumbs"
);

for (i = 0; i < sliderProductImgs.length; i++) {
  sliderProductImgs[i].classList.add("swiper-product-img-" + i);
  sliderProductThumbs[i].classList.add("swiper-product-img-thumbs-" + i);

  var thumbs = new Swiper(".swiper-product-img-thumbs-" + i, {
    spaceBetween: 20,
    slidesPerView: 4,
    watchSlidesProgress: true,
  });

  var galleries = new Swiper(".swiper-product-img-" + i, {
    slidesPerView: 1,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-summary-next",
      prevEl: ".swiper-button-summary-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
    },
    thumbs: {
      swiper: thumbs,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 100,
  });
}

//
// =DETAILS TOGGLING
// --------------------------------------------------

const details = document.querySelectorAll("details:not(open)");
const closeBtns = document.querySelectorAll("[data-dismiss]");
const detailsWrapper = document.querySelector(".msdw-grid-2");

// one details element opened at a time:
// click on any not-opened details will close the others

function closeAllBut(openDetails) {
  for (var i = 0; i < details.length; i++) {
    if (details[i] != openDetails) {
      details[i].open = false;
    }
  }
}

// non clicked details will grey out the text

details.forEach((el) => {
  el.querySelector("summary").addEventListener("click", () => {
    closeAllBut(el);

    if (el.hasAttribute("open")) {
      detailsWrapper.classList.remove("msdw-details-active");
    } else {
      detailsWrapper.classList.add("msdw-details-active");
    }

    // console.log(galleries);
    // document.querySelector(".swiper-product-img-" + i)[0].slideTo(0);
    // galleries.$el[0].swiper.slideTo(0);
    // galleries.$el[0].swiper.init(".swiper-product-img-" + i);
  });

  // once clicked, scroll to the element

  el.addEventListener("toggle", () => {
    let elTop = el.getBoundingClientRect().top;
    window.scrollTo({
      left: 0,
      top: window.scrollY + elTop - 60,
      behavior: "smooth",
    });
  });
});

// click on close button will close all details
// and back to normal text color

closeBtns.forEach((el) => {
  el.addEventListener("click", (e) => {
    closeAll();
    e.stopPropagation();
  });
});

function closeAll(el) {
  document
    .querySelectorAll("details")
    .forEach((el) => el.removeAttribute("open"));
  detailsWrapper.classList.remove("msdw-details-active");
}

document.onkeydown = (e) => {
  e = e || window.event;
  let isEscape = false;
  if ("key" in e) {
    isEscape = e.key === "Escape" || e.key === "Esc";
  } else {
    isEscape = e.keyCode === 27;
  }
  if (isEscape) {
    closeAll();
  }
};

//
// =PRODUCT PICKER
// --------------------------------------------------

const productPickers = document.querySelectorAll(".msdw-product-detail-picker");

productPickers.forEach((productPicker) => {
  const productIdNumber = productPicker.dataset.productId;
  productPicker.addEventListener("click", (e) => {
    e.preventDefault();
    window.jwsdwMediator.publish("openPicker", "productDetailPicker", {
      productId: productIdNumber,
    });
  });
});


//
// =VIDEO POP-UP
// --------------------------------------------------

// const playVideoBtns = document.querySelectorAll(".msdw-play-video");
// const msdwPopupVideoWrapper = document.querySelector(
//   ".msdw-popup-video-wrapper"
// );
// const msdwPopupVideoBackDrop = document.querySelector(
//   ".msdw-popup-video-backdrop"
// );
// const msdwPopupVideo = document.getElementById("msdwPopupVideo");

// if (document.contains(msdwPopupVideoWrapper)) {
//   // OPEN
//   playVideoBtns.forEach((playVideoBtn) => {
//     playVideoBtn.addEventListener("click", (e) => {
//       e.preventDefault();
//       const videoUrl = playVideoBtn.getAttribute("data-modal-video");
//       msdwPopupVideo.setAttribute("src", videoUrl);
//       msdwPopupVideoWrapper.classList.add("msdw-active");
//       document.body.classList.add("jws-overflowHidden");
//       msdwPopupVideo.muted = false;
//       msdwPopupVideo.play();
//     });
//   });

//   // CLOSE
//   const closePopUpVideo = () => {
//     document.body.classList.remove("jws-overflowHidden");
//     msdwPopupVideo.muted = true;
//     msdwPopupVideo.pause();
//     msdwPopupVideo.currentTime = 0;

//     msdwPopupVideoWrapper.classList.remove("msdw-active");
//   };

//   msdwPopupVideoBackDrop.addEventListener("click", () => {
//     closePopUpVideo();
//   });

//   window.onkeydown = (e) => {
//     if (e.keyCode == 27) closePopUpVideo();
//   };
// }

//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------
$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        console.log(offsetValue);
      } else {
        offsetValue = 99;
        console.log(offsetValue);
      }
      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------

const sliderSlot = document.getElementById('msdwSlidetSlot');
const catLandingMiddle = document.getElementById('cat-landing-middle');
catLandingMiddle && sliderSlot.appendChild(catLandingMiddle);

const sliderClasses = catLandingMiddle.children[0].classList;
sliderClasses.replace("jws-grid-medium-column-11", "jws-grid-medium-column-12");
sliderClasses.remove("jws-grid-small-shift-1");

